export default {
  welcome: "欢迎回来，{email}",
  subtitle: "在此管理您的帐户并查看订阅详情。",
  currentPlan: "当前计划",
  usageStatistics: "用量",
  manageTitle: "管理您的计划",
  monthlyImages: "月度图片",
  monthlyCredits: "月度积分",
  trialCredits: "永久积分",
  validPeriod: "有效期",
  monthlyUsage: "月度使用",
  trialUsage: "永久使用",
  uploadNewImage: "上传新图片",
  viewHistory: "查看历史记录",
  getSupport: "获取支持",
  upgradeButton: "升级计划",
  currentPlanBadge: "当前计划",
  unlimitedUsage: "无限制使用",
  limitReached: "已达到月度限制",
  creditsUnit: "积分",
  imagesRemaining: "本月还剩 {count} 积分",
  onlyRemaining: "本月仅剩 {count} 积分",
  planType: "计划类型",
  billingPeriod: "计费周期",
  billingPeriodMonthly: "按月",
  billingPeriodAnnual: "按年",
  billingPeriodOneTime: "一次性",
  billingPeriodUnknown: "--",
  planCancelAtPeriodEndNotice: "当前周期内您的方案仍然有效。",
  creditTotalAvailable: "可用总额",
  creditRemainingGranted: "剩余 {remaining} / 共 {granted}",
  creditUsed: "已用 {used}",
  creditValidityRange: "有效期 {start} – {end}",
  cycleCreditsUnavailable: "当前无月度周期额度",
  downgradeButton: "降级",
  plans: {
    free: {
      title: "免费版",
      period: "/月",
      features: {
        0: "新用户获赠 15 credits",
        1: "上传图和参考图差异分析",
        2: "AI 后期编辑指南",
        3: "基础分析功能免费",
        4: "部分高级分析功能可使用积分解锁",
        5: "5 条历史记录",
      },
    },
    standard: {
      title: "标准版",
      period: "/月",
      features: {
        0: "每月 90 credits",
        1: "差异分析可视化可使用积分解锁",
        2: "像素检查器、调色盘分析功能可使用积分解锁",
        3: "100 条历史记录",
        4: "支持 credit 加量包",
        5: "未使用的积分在订阅期间可结转一个计费周期",
      },
      subtitle: "免费版的全部功能，以及",
    },
    pro: {
      title: "专业版",
      period: "/月",
      badge: "最受欢迎",
      features: {
        0: "每月 200 credits",
        6: "差异分析可视化免费",
        1: "像素检查器免费",
        2: "调色盘分析功能免费",
        3: "Pro 专属功能免费：亮度/RGB精细可视化映射",
        4: "300 条历史记录",
        5: "未使用的积分在订阅期间可结转一个计费周期",
      },
      subtitle: "标准版的全部功能，以及",
    },
  },
  buttonText: {
    currentPlan: "当前计划",
    upgrade: "升级",
    unavailable: "不可用",
    managePlan: "管理方案",
    oneOff: "一次性购买",
    periodUnavailable: "该计费周期暂不可用",
  },
  billingErrors: {
    checkoutConflict: "您已有有效订阅，请前往管理订阅进行调整。",
    oneOffConflict: "您已有有效额度，请在到期后再购买。",
    portalForbidden: "仅订阅用户可进入管理入口。",
    confirmNotPaid: "支付仍在确认中，请稍后刷新。",
    confirmFailed: "支付确认失败，请稍后再试。",
    statusUnavailable: "支付状态暂不可用，请稍后再试。",
    statusSyncFailed: "无法加载您的计费状态，已临时禁用购买，请重试。",
    statusAuthError: "登录会话已过期，请重新登录以管理订阅。",
    checkoutUrlMissing: "无法发起订阅，请重试。",
    checkoutCreateFailed: "订阅会话创建失败，请稍后重试。",
    portalUrlMissing: "无法打开账单管理，请重试。",
    portalCreateFailed: "账单管理会话创建失败，请稍后重试。",
    externalRedirect: "跳转未完成，请重试或联系客服。",
    externalRedirectBlocked: "该支付链接疑似不安全已被拦截，请联系客服。",
  },
  statusBanner: {
    syncFailed: "计费状态加载失败，恢复前已暂停购买。",
    authError: "登录会话已过期，请重新登录以继续。",
    retry: "重试",
    loginAction: "登录",
    returnPending: "我们正在确认您的支付，您可以重试或刷新页面。",
    returnPendingRetry: "重新检查",
    dismiss: "关闭",
  },
  status: {
    paid: "已生效",
    trial: "试用中",
    expired: "已过期",
  },
  paymentCancel: {
    title: "支付已取消",
    description1: "您的支付已取消。",
    description2: "您可以返回仪表板，继续浏览 PhotoScope。",
    backToDashboard: "返回仪表板",
    resumePlans: "继续浏览套餐"
  },
};
